import { render } from "./SelecionarPerfilUsuario.vue?vue&type=template&id=d9169be0&scoped=true&ts=true"
import script from "./SelecionarPerfilUsuario.vue?vue&type=script&lang=ts"
export * from "./SelecionarPerfilUsuario.vue?vue&type=script&lang=ts"

import "./SelecionarPerfilUsuario.vue?vue&type=style&index=0&id=d9169be0&scoped=true&lang=css"

import exportComponent from "D:\\Desenvolvimento\\NeoXApp\\NeoX.Frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d9169be0"]])

export default __exports__